module.exports = __webpack_public_path__ + "static/media/sketch3.b053e708.jpg";